export const selectEquipmentDocumentType = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-equipment-document-type.html'),
    controller: 'SelectEquipmentDocumentTypeController'
};
